// @flow

export const EVENT_ACTIONS = {
  ME_UPDATED: 'EVENTS_ME_UPDATED',
  ARTIST_COMMISSION_SUBMIT: 'ARTIST_COMMISSION_SUBMIT',
  ARTWORK_ENQUIRE_SUBMIT: 'ARTWORK_ENQUIRE_SUBMIT',
  CMS_ENQUIRE_SUBMIT: 'CMS_ENQUIRE_SUBMIT',
};
